if (!customElements.get('sticky-atc')) {
  // Third-party widgets (chat bubbles, etc.) don't share a stable selector
  // across stores/app versions, so instead of hardcoding one we detect them
  // by how they're positioned and explicitly skip the theme's own fixed
  // elements below. Rather than trying to reposition a widget we don't
  // control, we just hide it while our bar covers the same corner.
  const KNOWN_THEME_FIXED_SELECTORS = [
    '.sticky-atc',
    '.sticky-cta',
    '.scroll-to-top-button',
    '.cart-notification',
    '.cart-drawer',
    '.menu-drawer',
    '.drawer__overlay',
    '.popup',
    '.age_verifier',
    '.search-modal',
    'quick-add-modal',
  ];

  class StickyATC extends HTMLElement {
    connectedCallback() {
      this.target = document.querySelector(this.dataset.target);
      this.hiddenWidgets = new Set();

      console.log('[sticky-atc] loaded, watching target:', this.target);

      if (!this.target || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { threshold: 0 });
      this.observer.observe(this.target);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      clearInterval(this.reapplyInterval);
    }

    handleIntersect(entries) {
      const [entry] = entries;
      const scrolledPast = entry.boundingClientRect.bottom < 0;
      this.classList.toggle('sticky-atc--visible', scrolledPast);
      this.setAttribute('aria-hidden', String(!scrolledPast));
      document.documentElement.style.setProperty(
        '--sticky-atc-height',
        scrolledPast ? `${this.offsetHeight}px` : '0px'
      );

      this.toggleOverlappingWidgets(scrolledPast);

      clearInterval(this.reapplyInterval);
      if (scrolledPast) {
        this.reapplyInterval = setInterval(() => this.toggleOverlappingWidgets(true), 500);
      } else {
        this.hiddenWidgets.forEach((el) => (el.style.visibility = ''));
        this.hiddenWidgets.clear();
      }
    }

    toggleOverlappingWidgets(shouldHide) {
      const all = document.querySelectorAll('body *');
      let fixedCount = 0;

      all.forEach((el) => {
        if (el === this || this.contains(el)) return;
        if (KNOWN_THEME_FIXED_SELECTORS.some((sel) => el.closest(sel))) return;

        const style = getComputedStyle(el);
        if (style.position !== 'fixed') return;
        fixedCount++;

        const rect = el.getBoundingClientRect();
        const willHide = rect.width > 0 && rect.height > 0
          && rect.width <= 200 && rect.height <= 200
          && rect.bottom >= window.innerHeight - 200;

        console.log('[sticky-atc] fixed element:', el.tagName.toLowerCase(), {
          id: el.id,
          class: el.className,
          rect: { w: Math.round(rect.width), h: Math.round(rect.height), bottom: Math.round(rect.bottom) },
          viewportHeight: window.innerHeight,
          willHide,
          el,
        });

        if (!willHide) return;

        el.style.visibility = shouldHide ? 'hidden' : '';
        this.hiddenWidgets.add(el);
      });

      console.log(`[sticky-atc] scan done: ${all.length} elements total, ${fixedCount} position:fixed (excluding known theme ones)`);
    }
  }

  customElements.define('sticky-atc', StickyATC);
}
